import { salesRepLogin } from '../user.helper';

export const salesRepLoggedInEvent = salesRepLogin.fulfilled;
